export class AuthorizationData {
  token: string;
}
